import { makeStyles } from '@fluentui/react-components'

/**
 * Fluent (Griffel) styles for the composer's toolbar buttons.
 *
 * Written with `makeStyles` rather than a CSS module because Griffel injects at
 * runtime and would otherwise win on order alone — this is the supported way to
 * restyle a Fluent `Button`. Values come from the Ask Bar frame.
 */
export const useComposerButtonStyles = makeStyles({
  circle: {
    width: '32px',
    height: '32px',
    minWidth: '32px',
    maxWidth: '32px',
    padding: '0',
    border: 'none',
    cornerShape: 'round',
    borderRadius: '32px',
    backgroundColor: 'var(--app-bg-hover)',
    color: 'var(--app-text-secondary)',
    ':hover': { backgroundColor: 'var(--app-bg-active)', color: 'var(--app-text-primary)' },
    ':hover:active': { backgroundColor: 'var(--app-bg-active)' },
  },
  sendIdle: {
    color: 'var(--app-do-send-idle)',
    ':hover': { backgroundColor: 'var(--app-bg-hover)', color: 'var(--app-do-send-idle)' },
  },
  /* Flat ink, not the brand gradient: the frame reserves colour for the reply
   * itself, and send sits beside two other 32px circles that would otherwise
   * be competing for the same attention. */
  sendActive: {
    backgroundColor: 'var(--app-text-primary)',
    color: 'var(--app-bg-hover)',
    ':hover': { backgroundColor: 'var(--app-text-primary)', color: 'var(--app-bg-hover)' },
    ':hover:active': { backgroundColor: 'var(--app-text-primary)' },
  },
  sendIcon: { width: '16px', height: '16px', fontSize: '16px' },
})
